// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/settings.js';

import { paths } from '../generated/settings';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('settings', Original, paths);
